import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  image,
  type = "website",
  publishedTime,
  author,
  siteName = "BBSR Services",
}) => {
  const siteUrl = "https://www.bbsrservices.co.in";
  const defaultImage = `${siteUrl}/default-og-image.jpg`;

  const metaTitle = title ? `${title} | ${siteName}` : siteName;
  const metaDescription =
    description || "BBSR Services - Professional Business Solutions";
  const metaImage = image || defaultImage;
  const metaUrl = canonical || window.location.href;

//   console.log("SEO Meta Tags:", {
//     title, // raw prop passed in
//     siteName, // raw prop passed in
//     metaTitle,
//     metaDescription,
//     metaImage,
//     metaUrl,
//   });

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={metaUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* Article Specific Meta Tags */}
      {type === "article" && (
        <>
          {publishedTime && (
            <meta property="article:published_time" content={publishedTime} />
          )}
          {author && <meta property="article:author" content={author} />}
        </>
      )}

      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />

      {/* Schema.org JSON-LD for Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: siteName,
          url: siteUrl,
          logo: `${siteUrl}/logo.png`,
          description: metaDescription,
          sameAs: [
            "https://www.facebook.com/bbsrservices",
            "https://twitter.com/bbsrservices",
            "https://www.linkedin.com/company/bbsrservices",
          ],
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
